import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import SecurityReportPageUI from './SecurityReportPageUI'
import CacheManager from "../../../cache/CacheManager";
import CacheKeys from '../../../cache/CacheKeys'
import RestApiUtils from "../../../apiclient/moebli/RestApiUtils";

class SecurityReportPageSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errorList: null,
            dsraReportList: null,
            onDownloadDsraReportRequested: false,
            response: null
        }
    }

    render() {
        return (
            <SecurityReportPageUI
                context={this.props.context}
                errorList={this.state.errorList}
                dsraReportList={this.state.dsraReportList}
                response={this.state.response}
                onDownloadDsraReport={this.onDownloadDsraReport}
                onDownloadDsraReportRequested={this.state.onDownloadDsraReportRequested}
                onRefreshClick={this.onRefreshClick}
            />
        )
    }

    componentDidMount() {
        let context = this.props.context
        let cacheManager = new CacheManager({
            resource: `dummy`,
            cacheKey: CacheKeys.DSRAReport()
        })
        let checkedObj = cacheManager.getObjectFromCache()
        if (checkedObj)
            this.setState({ checked: checkedObj.checked })
        this.getReport(context)
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.year == prevProps.match.params.year && this.props.match.params.month == prevProps.match.params.month)
            return
        this.getReport(this.props.context)
    }

    getReport(context) {
        // const cacheKey = this.props.match.params.year && this.props.match.params.month
        //     ? CacheKeys.DSRAReport(this.props.match.params.year, this.props.match.params.month)
        //     : CacheKeys.DSRAReport();
        let cacheManager = new CacheManager({
            resource: `/api/su/accounts/loans/security`,
            cacheKey: CacheKeys.DSRAReport(this.props.match.params.year, this.props.match.params.month),
            callback: this.getReportCallback,
            ttlInSecs: 600
        })
        if (!this.props.match.params.year || !this.props.match.params.month)
            cacheManager.getObject2(context, {}, {})
        else
            cacheManager.getObject2(context, {}, {
                year: this.props.match.params.year,
                month: this.props.match.params.month,
            })
    }


    getReportCallback = (response) => {
        this.setState({ errorList: response.errorList, dsraReportList: response.dsraReportList, response: response })
    }

    onDownloadDsraReport = () => {
        let context = this.props.context
        this.setState({ onDownloadDsraReportRequested: true })
        RestApiUtils.get(context, `/api/su/accounts/loans/dsra/excel/fileDownloadSignedUrl`,
            this.getDownloadDsraReportCallback, {})
    }

    getDownloadDsraReportCallback = (response) => {
        this.setState({ onDownloadDsraReportRequested: false })

        if (response.errorList.length === 0) {
            const link = document.createElement('a')
            link.href = response.signedUrl.signedUrl
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }
    }

    onRefreshClick = () => {
        let context = this.props.context
        CacheManager.removeObject(CacheKeys.DSRAReport(this.props.match.params.year, this.props.match.params.month))
        CacheManager.removeObject(CacheKeys.DSRAReport())
        this.setState({ dsraReportList: null, errorList: null }, () => {
            this.getReport(context)
        })
    }
}

export default withRouter(SecurityReportPageSF)